import * as MR from './checkout';

let selectedCarrierExtraContent = null;
let flagPaymentStepNeedsRefresh = null;
let isPaymentStepReachable = null;
let initializationGeneration = 0;

const getCarrierExtraContent = (input) => {
  let selected = input.closest('.delivery-options__item').find('.carrier__extra-content');
  if (!selected.length) {
    selected = input.closest('.delivery-option__item').find('.js-carrier-extra-content, .js-carrier-extra').first();
  }
  if (!selected.length) {
    selected = input.closest('.delivery-option').next('.carrier-extra-content');
  }
  return selected;
};

const getDeliveryAddressWidgetParams = () => {
  const inlineAddress = $('#opc-delivery-address-fields:not(.d-none)');
  const selectedAddress = $('#opc-delivery-address-content-list:not(.d-none)')
      .find('[name="id_address_delivery"]:checked')
      .closest('.opc-address-item');
  const postcode = inlineAddress.find('[name="postcode"]').val()
      || selectedAddress.find('[data-postcode]').first().attr('data-postcode')
      || MONDIALRELAY_POSTCODE;
  const country = window.prestashop?.country?.iso_code || MONDIALRELAY_COUNTRY_ISO;

  return {
    Country: country,
    PostCode: postcode,
  };
};

const getWidgetParams = (carrierId = MR.getSelectedCarrierId()) => ({
  ...MR.widget.getPersistedRelayParams(),
  ...getDeliveryAddressWidgetParams(),
  ColLivMod: MR.getCarrierDeliveryMode(carrierId),
});

const setSelectedCarrierExtraContent = () => {
  selectedCarrierExtraContent = getCarrierExtraContent($('[name^="delivery_option"]:checked'));
  return selectedCarrierExtraContent;
};

const fixPrepareMondialRelay = (id_carrier) => {
  selectedCarrierExtraContent = getCarrierExtraContent($('#delivery_option_' + id_carrier));
  return selectedCarrierExtraContent;
};

const setProcessLocked = (lock) => {
  const step = $("#checkout-delivery-step");
  const button = $("button[name='confirmDeliveryOption']");

  if (lock) {
    step.removeClass('-complete');
    button.attr('disabled', true);
  } else {
    step.addClass('-complete');
    button.attr('disabled', false);
  }
};

const forceDisableMaxHeightUntilLoaded = () => {
  const wrapper = selectedCarrierExtraContent.closest(
      '.carrier__extra-content-wrapper, .carrier__extra-content-wrap, .carrier-extra-content, .delivery-option__extra'
  );

  if (!wrapper.length) return;

  const interval = setInterval(() => {
    const contentHeight = wrapper.find('.carrier__extra-content')[0]?.scrollHeight || 0;

    if (contentHeight > 100) {
      wrapper.each(function() {
        this.style.removeProperty('max-height');
        this.style.removeProperty('overflow');
      });

      clearInterval(interval);
    }
  }, 1000);
};

const forceDisplayMondialRelayContent = () => {
  const wrapper = selectedCarrierExtraContent.closest(
      '.carrier__extra-content-wrapper, .carrier__extra-content-wrap, .carrier-extra-content, .delivery-option__extra'
  );

  if (wrapper.length) {
    wrapper.each(function () {
      this.style.setProperty('display', 'block', 'important');
      this.style.removeProperty('max-height');
      this.style.removeProperty('overflow');
    });
  }

  if (selectedCarrierExtraContent.length) {
    selectedCarrierExtraContent.each(function () {
      this.style.setProperty('display', 'block', 'important');
    });
  }
};


const initializeMondialRelay = () => {
  const carrierId = MR.getSelectedCarrierId();
  if (!carrierId || !MR.isRelayCarrierSelected()) {
    MR.syncPersistedRelay();
    MR.widget.hide();
    return;
  }

  setSelectedCarrierExtraContent();
  if (!selectedCarrierExtraContent.length) {
    fixPrepareMondialRelay(carrierId);
  }
  if (!selectedCarrierExtraContent.length || !$('#mondialrelay_content').length) {
    return;
  }

  $('#mondialrelay_content').appendTo(selectedCarrierExtraContent);
  forceDisplayMondialRelayContent();
  forceDisableMaxHeightUntilLoaded();

  const hasPersistedRelay = MR.syncPersistedRelay();
  if (!hasPersistedRelay) {
    MR.widget.show();
  }

  MR.widget.initOrUpdate(getWidgetParams(carrierId));
};

const scheduleMondialRelayInitialization = () => {
  const generation = ++initializationGeneration;
  window.setTimeout(() => {
    if (generation === initializationGeneration) {
      initializeMondialRelay();
    }
  }, 0);
};

$(MR.widget).on('mondialrelay.ready', function() {
  if (MR.isRelayCarrierSelected()) {
    setSelectedCarrierExtraContent();
    forceDisplayMondialRelayContent();
    forceDisableMaxHeightUntilLoaded();

    if (isPaymentStepReachable === null) {
      isPaymentStepReachable = $("#checkout-payment-step").hasClass('-reachable');
    }
    $("#checkout-payment-step").removeClass('-reachable').addClass('-unreachable');

    $('#mondialrelay_content').appendTo(selectedCarrierExtraContent);

    if (!MR.syncPersistedRelay()) {
      setProcessLocked(true);
      MR.widget.show();
    } else {
      $(MR.widget.summary_container).show();
      MR.widget.hide();

      if ($("#checkout-payment-step").hasClass('-unreachable')) {
        $("#checkout-payment-step").removeClass('-unreachable').addClass('-reachable');
      }
    }

    initializeMondialRelay();
  }

  $(MR.widget.widget_container).on('click', function(ev) {
    ev.preventDefault();
    ev.stopPropagation();
  });
});

$(document).on('change', '#js-delivery [name^="delivery_option"]', function() {
  if (!MR.isRelayCarrierSelected()) {
    if (selectedCarrierExtraContent) {
      selectedCarrierExtraContent.hide();
      selectedCarrierExtraContent = null;
    }
    setProcessLocked(false);
    MR.clearPersistedRelay();

    if (flagPaymentStepNeedsRefresh) {
      $("#checkout-payment-step .content").append(flagPaymentStepNeedsRefresh);
      flagPaymentStepNeedsRefresh = null;
    }
    if (isPaymentStepReachable !== null && isPaymentStepReachable) {
      $("#checkout-payment-step").addClass('-reachable').removeClass('-unreachable');
    }

    return;
  }

  flagPaymentStepNeedsRefresh = $('.js-cart-payment-step-refresh').clone();
  $('.js-cart-payment-step-refresh').remove();

  if (isPaymentStepReachable === null) {
    isPaymentStepReachable = $("#checkout-payment-step").hasClass('-reachable');
  }
  $("#checkout-payment-step").removeClass('-reachable').addClass('-unreachable');

  if (!MR.widget.savedRelay) {
    setProcessLocked(true);
    MR.widget.show();
  } else if (!$(this).is(MR.widget.selected_relay_input)) {
    MR.widget.hide();
  }

  if (selectedCarrierExtraContent) {
    selectedCarrierExtraContent.hide();
  }

  setSelectedCarrierExtraContent();
  $('#mondialrelay_content').appendTo(selectedCarrierExtraContent);
  forceDisplayMondialRelayContent();
  forceDisableMaxHeightUntilLoaded();
  MR.widget.initOrUpdate(getWidgetParams());
});

$(document).on('submit', '#js-delivery', function(ev) {
  if (MR.isRelayCarrierSelected() && !MR.widget.savedRelay) {
    ev.preventDefault();
    ev.stopPropagation();

    setSelectedCarrierExtraContent();
    $('#mondialrelay_content').appendTo(selectedCarrierExtraContent);
    forceDisplayMondialRelayContent();
    forceDisableMaxHeightUntilLoaded();

    MR.widget.initOrUpdate(getWidgetParams());

    alert(MR.getRelaySelectionError());
    return false;
  }
  return true;
});

prestashop.on('updatedDeliveryForm', function() {
  scheduleMondialRelayInitialization();
});

prestashop.on('opcCarriersUpdated', scheduleMondialRelayInitialization);
prestashop.on('opcCarrierSelected', scheduleMondialRelayInitialization);

const resetRelayForAddressChange = () => {
  initializationGeneration += 1;
  MR.clearPersistedRelay();
  MR.widget.hide();
};

prestashop.on('opcDeliveryAddressUpdated', resetRelayForAddressChange);
prestashop.on('opcDeliveryAddressSelected', resetRelayForAddressChange);

prestashop.on('opcAddressPersisted', function(response) {
  if (!response || Number(response.id_address_delivery) <= 0) {
    return;
  }

  resetRelayForAddressChange();
  scheduleMondialRelayInitialization();
});

$(document).on('mondialrelay.contentRefreshed', '#mondialrelay_content', function() {
  MR.widget.initialized = false;
  scheduleMondialRelayInitialization();
});

const blockOpcWithoutRelay = (event) => {
  const isOpcSubmit = event.type === 'submit' && $(event.target).is('#opc-form');
  const isOpcPayClick = event.type === 'click' && $(event.target).closest('#opc-pay-button').length;

  if ((!isOpcSubmit && !isOpcPayClick)
      || !MR.isRelayCarrierSelected()
      || MR.isPersistedRelayValid()
  ) {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();
  setSelectedCarrierExtraContent();
  $('#mondialrelay_content').appendTo(selectedCarrierExtraContent);
  forceDisplayMondialRelayContent();
  MR.widget.displayErrors([MR.getRelaySelectionError()]);
  MR.widget.show();
  MR.widget.initOrUpdate(getWidgetParams());
};

document.addEventListener('submit', blockOpcWithoutRelay, true);
document.addEventListener('click', blockOpcWithoutRelay, true);

$('#js-delivery').on('change', '#mondialrelay_content *', function(ev) {
  ev.preventDefault();
  ev.stopPropagation();
});

$(MR.widget).on('mondialrelay.saveSelectedRelay.before', function() {
  setProcessLocked(true);
  $("[name^='delivery_option']")
      .attr('readonly', true)
      .on('click.mondialrelay.lock', function(ev) {
        ev.preventDefault();
        ev.stopPropagation();
      });
});

$(MR.widget).on('mondialrelay.saveSelectedRelay.success', function() {
  setProcessLocked(false);
  $("[name^='delivery_option']")
      .attr('readonly', false)
      .off('click.mondialrelay.lock');
});

$(MR.widget).on('mondialrelay.saveSelectedRelay.error', function() {
  setProcessLocked(true);
  $("[name^='delivery_option']")
      .attr('readonly', false)
      .off('click.mondialrelay.lock');
});

window.mondialrelayWidget = MR.widget;
